(function() {
    'use strict';
    
a3_cabin_reports.controller('MessageCtrl',MessageCtrl);

    /**
    * @memberof CabinReports
    * @ngdoc controller
    * @name MessageCtrl
    * @description 
    *  Manages the messages View
    * @ngInject
    */
function MessageCtrl($scope, MessageFactory, $filter, $sce) {

		var messages = []

        $scope.messages = MessageFactory.getMessagesFromStorage();
        messages = $scope.messages;

		
		$scope.messageCount = messages.length;
		$scope.state = 'messages';
		$scope.openMessage = openMessage;
		$scope.isEnabled = false;
		$scope.setupView = setupView;
        $scope.trustAsHtml = trustAsHtml;

         /**
         * Trust this html style text
         * @memberof MessageCtrl
         * @param {string} body The body message
         */
        function trustAsHtml(body){
            
           return $sce.trustAsHtml(body);
        }
		
         /**
         * Setup the message View
         * @memberof MessageCtrl
         * @param {boolean} isEnabled Show only unread messages
         */
		function setupView(isEnabled) {
			$scope.messages = $filter('messageFilter')(messages, isEnabled);
		}

        /**
         * View Selected message
         * @memberof MessageCtrl
         * @param {object} message The selected Message
         */
		function openMessage(message) {
			if (message.ReadDt == null) {
				MessageFactory.markReaden(message.Id);
				message.ReadDt = new Date();
			}
		}

	}

})();